import { requestHandler } from '../../api';

export const getAllReversedCessionsNominees = async (
  dispatch: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reversedCessions?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getReversedCessionsNominee = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reversedCessions/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createDocumentsForCession = async (
  dispatch: any,
  data: {
    documents: any[];
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/reversedCessions/createDocumentsForRecession`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getCessionsToCreateNominee = async (
  dispatch: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/reversedCessions/availableCessions?${query}`,
    dispatch,
  });
  if (response) return response.data;
};
